<template>
	<div class='planting-specifics'>
		<div class='grid'>

			<div :class='{ "not-match": !isMatch(values["is_low_density_natural"]) }'>
				<custom-p-checkbox v-model='values["is_low_density_natural"].value' label='Естественное низкополнотное' :disabled='!actLpoIsDraft'/>
			</div>

			<div :class='{ "not-match": !isMatch(values["is_low_bonitet_natural"]) }'>
				<custom-p-checkbox v-model='values["is_low_bonitet_natural"].value' label='Лесные насаждения 4 и 5 бонитетов являются преобладающими в лесничестве' :disabled='!actLpoIsDraft'/>
			</div>

			<div :class='{ "not-match": !isMatch(values["is_drained"]) }'>
				<custom-p-checkbox v-model='values["is_drained"].value' label='Осушенное' :disabled='!actLpoIsDraft'/>
			</div>

			<div :class='{ "not-match": !isMatch(values["is_after_tapping"]) }'>
				<custom-p-checkbox v-model='values["is_after_tapping"].value' label='После подсочки' :disabled='!actLpoIsDraft'/>
			</div>

			<div :class='{ "not-match": !isMatch(values["is_artificial"]) }'>
				<custom-p-checkbox v-model='values["is_artificial"].value' label='Искусственное' :disabled='!actLpoIsDraft'/>

				<div v-if='values["is_artificial"].value' class='planting-year-block' :class='{ "not-match": !isMatch(values["planting_year"]) }'>
					<span>Год посадки</span>
					<custom-p-select
						v-model='values["planting_year"].value'
						:options='info_age'
						:optionLabel='null'
						:dataKey='null'
						:disabled='!actLpoIsDraft'
					/>
				</div>
			</div>

			<div :class='{ "not-match": !isMatch(values["is_fire_hazard"]) }'>
				<custom-p-checkbox v-model='values["is_fire_hazard"].value' label='Угроза возникновения пожарной опасности' :disabled='!actLpoIsDraft'/>
			</div>

			<div :class='{ "not-match": !isMatch(values["is_pest_core_hazard"]) }'>
				<custom-p-checkbox v-model='values["is_pest_core_hazard"].value' label='Угроза возникновения очагов' :disabled='!actLpoIsDraft'/>
			</div>

			<div :class='{ "not-match": !isMatch(values["is_fire_burned"]) }'>
				<custom-p-checkbox v-model='values["is_fire_burned"].value' label='Пройденные пожаром' :disabled='!actLpoIsDraft'/>
			</div>
		</div>

		<div class='grid select-value-block'>

			<div :class='{ "not-match": !isMatch(values["age_group"]) }'>
				<span class='select-title'>Группа возраста</span>
				<custom-p-select
					v-model='values["age_group"].value'
					:options="info_age_groups"
					:disabled='catalogsAreLoading || !actLpoIsDraft'
				/>
			</div>

			<div :class='{ "not-match": !isMatch(values["radioactive_zone"]) }'>
				<span class='select-title'>Зона радиоактивного загрязнения</span>
				<custom-p-select
					v-model='values["radioactive_zone"].value'
					:options="info_radioactive_zone"
					:disabled='catalogsAreLoading  || !actLpoIsDraft'
				/>
			</div>
			<div :class='{ "not-match": !isMatch(values["bnt"]) }'>
				<span class='select-title'>Зона БПТ</span>
				<custom-p-select
					v-model='values["bnt"].value'
					:options="info_bnt"
					:disabled='catalogsAreLoading  || !actLpoIsDraft'
				/>
			</div>

		</div>

		<div class='values-btn-row not-match-block' v-if='notMatchingValues.length'>
			<div>
				<button @click='cancel'>Отмена</button>
				<button @click='save'>Сохранить</button>
			</div>
		</div>
		
	</div>
</template>

<script>
	import { mapState, mapActions } from 'vuex';

	const info_age = [];
	let currentAge = +(new Date().getFullYear());
	const lastAge = 1700;
	while (currentAge >= lastAge) {
		info_age.push(String(currentAge--));
	}

	export default {
		name: 'PlantingSpecifics',
		data() {
			return {
				info_age,

				values: {
					is_low_bonitet_natural: {
						field: 'is_low_bonitet_natural',
						inputType: 'checkbox',
						value: false,
					},
					is_low_density_natural: {
						field: 'is_low_density_natural',
						inputType: 'checkbox',
						value: false
					},
					is_drained: {
						field: 'is_drained',
						inputType: 'checkbox',
						value: false
					},
					is_after_tapping: {
						field: 'is_after_tapping',
						inputType: 'checkbox',
						value: false
					},
					is_artificial: {
						field: 'is_artificial',
						inputType: 'checkbox',
						value: false
					},
					is_fire_hazard: {
						field: 'is_fire_hazard',
						inputType: 'checkbox',
						value: false
					},
					is_pest_core_hazard: {
						field: 'is_pest_core_hazard',
						inputType: 'checkbox',
						value: false
					},
					is_fire_burned: {
						field: 'is_fire_burned',
						inputType: 'checkbox',
						value: false
					},

					planting_year: {
						field: 'planting_year',
						inputType: 'input',
						value: null,
					},

					age_group: {
						field: 'age_group_id',
						inputType: 'select',
						value: null,
						catalog: 'info_age_groups'
					},

					radioactive_zone: {
						field: 'radioactive_zone_id',
						inputType: 'select',
						value: null,
						catalog: 'info_radioactive_zone'
					},
					bnt: {
						field: 'bnt_id',
						inputType: 'select',
						value: null,
						catalog: 'info_bnt'
					}
				},

				catalogsAreLoading: false
			};
		},
		computed: {
			actLpoIsDraft() { return this.$store.getters['lpoData/actLpoIsDraft']; },

			notMatchingValues() {
				const result = [];

				for (const value_name in this.values) {
					if (!this.isMatch(this.values[value_name])) {
						result.push(value_name);
					}
				}

				return result;
			},

			selectedIsArtificial() {
				return this.values.is_artificial.value;
			},

			...mapState({
				lpo: state => state.selectedLpo.lpo,

				info_forest_zone: state => state.catalogs['info_forest_zone'],
				info_age_groups: state => state.catalogs['info_age_groups'],
				info_radioactive_zone: state => state.catalogs['info_radioactive_zone'],
				info_bnt: state => state.catalogs['info_bnt']
			})
		},
		watch: {
			selectedIsArtificial(is_artificial) {
				if (!is_artificial) {
					this.values.planting_year.value = null;
				}
			}
		},
		methods: {
			save() {
				const valueList = [];

				// console.log(this.notMatchingValues);
				// return;

				for (const value_name of this.notMatchingValues) {
					const inputTypeIsSelect = this.values[value_name].inputType === 'select';

					const temp = {
						field: this.values[value_name].field,
						value: inputTypeIsSelect && this.values[value_name].value ? this.values[value_name].value.id : this.values[value_name].value,
						// value: inputTypeIsSelect ? (this.values[value_name].value === null ? null : this.values[value_name].value.id) : this.values[value_name].value,
					};

					// const temp = {
					// 	field: this.values[value_name].field,
					// 	value: inputTypeIsSelect ? this.values[value_name].value.id : this.values[value_name].value
					// };
					valueList.push(temp);
				}

				// console.log(valueList);
				// return;

				this.saveLpoValue(valueList).then(res => {
					return this.updateLpo();
				});
			},
			cancel() {
				this.resetValues();
			},

			resetValues(...valueList) {
				for (let value_name in this.values) {
					const value = this.values[value_name];

					if (value.inputType === 'checkbox') {
						value.value = this.lpo[value.field] === 't';
					} else if (value.inputType === 'select') {

						const temp = this[value.catalog].find(item => {
							return item.id === this.lpo[value.field];
						});
						value.value = temp ? temp : null;

					} else if (value.inputType === 'input') {
						value.value = this.lpo[value.field];
					}
				}
			},
			
			isMatch(value) {
				if (this.catalogsAreLoading) {
					return true;
				}

				if (value.inputType === 'checkbox') {
					return value.value === (this.lpo[value.field] === 't');
				} else if (value.inputType === 'select') {
					if (!value.value) {
						return this.lpo[value.field] === null;
					} else {
						return value.value.id === this.lpo[value.field];
					}
				} else if (value.inputType === 'input') {
					return value.value === this.lpo[value.field];
				}

				return false;
			},

			...mapActions('selectedLpo', [
				'saveLpoValue',
				'updateLpo',
			])
		},
		created() {
			const catalogs = [ 'info_forest_zone', 'info_age_groups', 'info_radioactive_zone', 'info_bnt'];

			this.catalogsAreLoading = true;
			this.$store.dispatch('loadCatalogs', catalogs).then(res => {
				this.catalogsAreLoading = false;
				this.resetValues();
			});
		}
	};
</script>

<style scoped src='@/style/grid.css'></style>
<style scoped src='@/style/button.css'></style>

<style scoped>

	.not-match {
		background-color: orange;
	}

	.select-value-block {
		margin-top: 34px;
	}

	.select-title {
		font-weight: bold;
		display: inline-block;
		margin-bottom: 6px;
	}

</style>